import { useTab } from "@/hooks/useTab";
import { useFilters } from "@/hooks/useFilters";
import { Podium } from "@/components/cards/Podium";
import { RankingRow } from "@/components/cards/RankingRow";
import { EmptyState, ErrorState, SectionTitle, TabSkeleton } from "./shared";

/** Tab 5 — Credits-per-message efficiency podium + ranking. */
export function EfficiencyTab() {
  const { filters } = useFilters();
  const { data, isPending, error } = useTab("efficiency", filters);

  if (isPending) return <TabSkeleton />;
  if (error) return <ErrorState error={error} />;
  if (!data || (data.podium.length === 0 && data.ranking.length === 0)) {
    return <EmptyState title="Sin datos de eficiencia en este periodo." />;
  }

  return (
    <div className="flex flex-col gap-8">
      <section>
        <SectionTitle>Más eficientes</SectionTitle>
        <Podium entries={data.podium} metricLabel="eff" />
      </section>
      <section>
        <SectionTitle>Ranking de eficiencia</SectionTitle>
        <div className="flex flex-col gap-2">
          {data.ranking.map((row) => (
            <RankingRow
              key={row.uid}
              rank={row.rank}
              username={row.username}
              team={row.team}
              score={row.messages_per_credit.toFixed(2)}
              badges={row.badges}
              metricLabel="msgs / crédito"
              secondary={{ value: row.messages, label: "msgs" }}
            />
          ))}
        </div>
      </section>
    </div>
  );
}
